import { Link } from "react-router-dom";
import { Avatar } from "antd";
import { EditOutlined } from "@ant-design/icons";
import EllipsisText from "components/EllipsisText";
import formatPhone from "helpers/phone_formatter";

const columns = [
  {
    title: "Numer pracownika",
    dataIndex: "position",
    sortable: true,
    searchable: true,
    search_method: "eq",
    width: 160,
  },
  {
    title: "Imię",
    dataIndex: "first_name",
    sortable: true,
    searchable: true,
    search_method: "matches",
    render: (_, { id, initials, first_name, color }) => (
      <>
        <Avatar
          style={{
            backgroundColor: color,
            marginRight: 10,
          }}
        >
          {initials}
        </Avatar>
        <Link to={`/workers/${id}`}>
          <EllipsisText text={first_name} limit={30} /> <EditOutlined />
        </Link>
      </>
    ),
  },
  {
    title: "Nazwisko",
    dataIndex: "last_name",
    sortable: true,
    searchable: true,
    search_method: "matches",
    render: (_, { last_name }) => <EllipsisText text={last_name} limit={30} />,
  },
  {
    title: "E-mail",
    dataIndex: "email",
    sortable: true,
    searchable: true,
    search_method: "matches",
    render: (_, { email }) => <EllipsisText text={email} limit={30} />,
  },
  {
    title: "Telefon",
    dataIndex: "phone",
    sortable: true,
    searchable: true,
    search_method: "matches",
    search_type: "number",
    render: (_, { phone }) => formatPhone(phone),
  },
  {
    title: "Status",
    dataIndex: "is_active",
    sortable: true,
    searchable: true,
    search_method: "in",
    search_component: "select",
    options: [
      { label: "Aktywny", value: 1 },
      { label: "Nieaktwyny", value: 0 },
    ],
    render: (_, { is_active }) => (is_active ? "Aktywny" : "Nieaktywny"),
  },
];

export default columns;
